var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": { minWidth: "100vw", minHeight: "100vh" },
        "no-backdrop-dismiss": "",
        "no-esc-dismiss": ""
      },
      model: {
        value: _vm.show_portfolio_modal,
        callback: function($$v) {
          _vm.show_portfolio_modal = $$v
        },
        expression: "show_portfolio_modal"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    _vm.show_portfolio_modal = false
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n\t\t\t\t" + _vm._s(_vm.$t("sort_portfolio")) + "\n\t\t\t"
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-padding" },
            [
              _vm._l(_vm.portfolio_areas, function(area) {
                return _c(
                  "q-list",
                  { key: area.id },
                  [
                    _c(
                      "q-collapsible",
                      {
                        staticClass: "text-bold",
                        attrs: {
                          group: "areas",
                          icon: "fas fa-layer-group",
                          label: area.name
                        }
                      },
                      [
                        _c(
                          "draggable",
                          {
                            staticClass: "row",
                            attrs: { list: area.group_trainings }
                          },
                          _vm._l(area.group_trainings, function(gt, index) {
                            return _c(
                              "q-card",
                              {
                                key: gt.id,
                                staticClass:
                                  "q-pa-xs cursor-pointer col-xs-12 col-md-2 col-2",
                                staticStyle: { width: "20%" },
                                attrs: { inline: "" },
                                nativeOn: {
                                  dragend: function($event) {
                                    return _vm.changeTrainingOrder.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "q-card-media",
                                  { attrs: { "overlay-position": "top" } },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: gt.image
                                          ? gt.image
                                          : _vm.getPlaceholder
                                      }
                                    }),
                                    _c(
                                      "q-card-title",
                                      {
                                        staticClass: "text-right",
                                        attrs: { slot: "overlay" },
                                        slot: "overlay"
                                      },
                                      [
                                        _c(
                                          "strong",
                                          {
                                            staticStyle: { display: "block" },
                                            attrs: { slot: "subtitle" },
                                            slot: "subtitle"
                                          },
                                          [_vm._v(_vm._s(gt.title))]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "subtitle" },
                                            slot: "subtitle"
                                          },
                                          [
                                            _c("q-icon", {
                                              staticClass: "q-mr-sm",
                                              attrs: {
                                                name: "fas fa-layer-group",
                                                color: "white",
                                                size: "1rem"
                                              }
                                            }),
                                            _c(
                                              "strong",
                                              {
                                                staticStyle: {
                                                  "font-size": "1rem"
                                                }
                                              },
                                              [_vm._v(_vm._s(index))]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-3 order-last" },
                  [
                    _c("q-btn", {
                      staticClass: "full-width",
                      attrs: {
                        color: "tertiary",
                        label: _vm.$t("back"),
                        icon: "fas fa-chevron-left"
                      },
                      on: {
                        click: function($event) {
                          _vm.show_portfolio_modal = false
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }